export default function StringMethods() {
	const toLower = (chars: unknown) => {
		return String(chars).toLowerCase()
	}
	const toCapitalize = (arg: string) => {
		return String(arg).charAt(0).toUpperCase() + String(arg).slice(1).toLowerCase()
	}
	const sanitizeId = (text: string) => {
		return (
			String(text)
				.toLowerCase()
				.replaceAll(/&nbsp;/g, '') // Remove non-breaking spaces
				.replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric characters except spaces and dashes
				// .replace(/\s+/g, '-') // Replace spaces with dashes
				.trim()
		)
	}
	const showProductName = (arg: string) => {
		return String(arg).replace('care', 'Care').replace('-', ' ')
	}
	const replaceContentPlaceholder = (content: string, className?: string, placeholder = '$ui') => {
		// Escaping any special characters in the placeholder
		const escapedPlaceholder = placeholder.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
		const regex = new RegExp(`${escapedPlaceholder}([\\w%]+)`, 'g')
		return String(content).replace(regex, `<span class="${className}">$1</span>`)
	}
	const stripHTMLTags = (input: string) => {
		// Use a regular expression to remove HTML tags
		return String(input).replace(/<\/?[^>]+(>|$)/g, '')
	}
	const extractHeadingsWithIds = (content: string) => {
		// Use a regex to match all h tags and their attributes
		const headingRegex = /<h([1-6])([^>]*)>(.*?)<\/h[1-6]>/gi
		let match
		const headings = []
		let updatedContent = content

		const wordLimit = (text: string, limit: number = 12) => {
			const words = String(text).split(' ')
			const first12Words = words.slice(0, limit)
			if (words.length > limit) {
				return first12Words.join(' ') + '...'
			}
			return text
		}

		// Process each match
		while ((match = headingRegex.exec(content)) !== null) {
			const level = match[1] // Heading level (1-6)
			const existingAttributes = match[2].trim() // Existing attributes
			const text = match[3].trim() // Text inside the tag
			const id = sanitizeId(stripHTMLTags(text)) // Generate ID

			// Add the heading info to the array
			headings.push({ text: wordLimit(stripHTMLTags(text), 4), id })

			// Check if the tag already has an id attribute
			const updatedAttributes = existingAttributes.replace(/id=".*?"/i, '').trim()

			// Reconstruct the tag with the new ID and retain other attributes
			const tagWithId = `<h${level} id="${String(id).replaceAll(
				' ',
				'-'
			)}" ${updatedAttributes}>${text}</h${level}>`.trim()

			// Replace the original tag in the content
			updatedContent = updatedContent.replace(match[0], tagWithId)
		}

		return { headings, updatedContent }
	}
	const boldAllText = (text: string, className?: string) => {
		return String(text).replace(/\$b(\s*)/, `<span class="${className} font-semibold">$1</span>`)
	}
	const boldText = (text: string, className = '') => {
		return String(text).replace(/\$b(\S+)/g, `<span class="${className} font-semibold">$1</span>`)
	}
	const processExternalLinks = (content: string, siteHost?: string) => {
		if (!content) return ''
		const currentHost = siteHost || 'mycovergenius.com'

		// Match the entire replacement for the opening <a> tag
		return content.replace(/<a\s+([^>]*?)href=(["'])(.*?)\2([^>]*?)>/gi, (match, before, quote, href, after) => {
			try {
				const isExternal =
					href.startsWith('http') && !href.includes(currentHost) && !href.startsWith('/') && !href.startsWith('#')

				if (isExternal) {
					if (!match.includes('target=')) {
						return `<a ${before}href=${quote}${href}${quote}${after} target="_blank" rel="noopener noreferrer">`
					}
				}
			} catch (e) {
				// Fallback
			}
			return match
		})
	}

	return {
		extractHeadingsWithIds,
		showProductName,
		toLower,
		toCapitalize,
		replaceContentPlaceholder,
		stripHTMLTags,
		boldAllText,
		boldText,
		processExternalLinks
	}
}
